import { Trash2, Upload, Image as ImageIcon } from "lucide-react";
import { API } from "@/lib/quotationApi";

export default function PaymentInfoSection({ form, patch, uploadingQr, onUploadQr, qrInputRef }) {
  return (
    <div
      className="rounded-xl border border-white/10 bg-white/[0.02] p-4 space-y-3"
      data-testid="branding-payment-section"
    >
      <label
        className="flex items-center justify-between gap-3 cursor-pointer"
        data-testid="branding-show-payment-info-toggle"
      >
        <span>
          <div className="font-display font-semibold text-[14px] mb-0.5">
            Show payment details on quotations
          </div>
          <div className="text-[11px] text-white/40">
            When enabled, bank, UPI & QR block appears near the grand totals on
            the public quotation, the PDF, and the WhatsApp message.
          </div>
        </span>
        <input
          type="checkbox"
          className="w-5 h-5 accent-[color:var(--primary)] shrink-0"
          checked={form.show_payment_info}
          onChange={(e) => patch("show_payment_info", e.target.checked)}
          data-testid="branding-show-payment-info-checkbox"
        />
      </label>

      <div className="overline text-white/40 pt-2">Bank transfer</div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        <div>
          <label className="label-luxe">Account holder name</label>
          <input
            className="input-luxe"
            value={form.bank_account_name}
            onChange={(e) => patch("bank_account_name", e.target.value)}
            placeholder="e.g. LIVANA Interiors Pvt Ltd"
            maxLength={80}
            data-testid="branding-bank-account-name-input"
          />
        </div>
        <div>
          <label className="label-luxe">Bank name</label>
          <input
            className="input-luxe"
            value={form.bank_name}
            onChange={(e) => patch("bank_name", e.target.value)}
            placeholder="e.g. HDFC Bank · Indiranagar"
            maxLength={80}
            data-testid="branding-bank-name-input"
          />
        </div>
        <div>
          <label className="label-luxe">Account number</label>
          <input
            className="input-luxe tracking-wider"
            value={form.bank_account_number}
            onChange={(e) => patch("bank_account_number", e.target.value)}
            placeholder="12-digit A/c no."
            maxLength={40}
            inputMode="numeric"
            data-testid="branding-bank-account-number-input"
          />
        </div>
        <div>
          <label className="label-luxe">IFSC code</label>
          <input
            className="input-luxe uppercase tracking-widest"
            value={form.ifsc_code}
            onChange={(e) => patch("ifsc_code", e.target.value.toUpperCase())}
            placeholder="e.g. HDFC0001234"
            maxLength={20}
            data-testid="branding-ifsc-input"
          />
        </div>
      </div>

      <div className="overline text-white/40 pt-2">UPI</div>
      <div>
        <label className="label-luxe">UPI ID / VPA</label>
        <input
          className="input-luxe"
          value={form.upi_id}
          onChange={(e) => patch("upi_id", e.target.value)}
          placeholder="e.g. livana@okicici"
          maxLength={80}
          data-testid="branding-upi-id-input"
        />
      </div>

      <div>
        <label className="label-luxe flex items-center gap-1.5">
          <ImageIcon size={11} /> UPI QR code
        </label>
        <div className="flex items-center gap-3">
          {form.qr_storage_path ? (
            <img
              src={`${API}/files/${form.qr_storage_path}`}
              alt="UPI QR preview"
              className="w-20 h-20 rounded-lg object-contain border border-white/10 bg-white/[0.04]"
              data-testid="branding-qr-preview"
            />
          ) : (
            <div className="w-20 h-20 rounded-lg border border-dashed border-white/15 flex items-center justify-center text-[10px] text-white/40 text-center px-2">
              No QR uploaded
            </div>
          )}
          <div className="flex-1 grid grid-cols-1 gap-2">
            <button
              onClick={() => qrInputRef.current?.click()}
              className="btn-ghost !h-10 text-sm flex items-center justify-center gap-2"
              disabled={uploadingQr}
              data-testid="branding-upload-qr-btn"
            >
              <Upload size={14} />
              {uploadingQr ? "Uploading…" : form.qr_storage_path ? "Replace QR" : "Upload QR"}
            </button>
            <button
              onClick={() => patch("qr_storage_path", "")}
              className="btn-ghost !h-10 text-sm flex items-center justify-center gap-2"
              disabled={!form.qr_storage_path}
              data-testid="branding-remove-qr-btn"
            >
              <Trash2 size={14} /> Remove
            </button>
            <input
              type="file"
              ref={qrInputRef}
              accept="image/png,image/jpeg,image/webp"
              className="hidden"
              onChange={onUploadQr}
            />
          </div>
        </div>
        <p className="text-[11px] text-white/40 mt-1.5">
          Square PNG/JPG works best. The QR will be embedded in the PDF and
          shown on the public quotation page.
        </p>
      </div>
    </div>
  );
}
